// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/views/Loads/BracketDesignLoading/styles.scss
// module id = 1316
// module chunks = 0